import React from "react";
import { AutoAwesome } from "@styled-icons/material-rounded/AutoAwesome";
import * as styles from "../styles";
import BatchUrlForm from "../components/BatchUrlForm";

const SearchPage: React.FC<{ onSubmit: (url: string) => Promise<void> }> = ({ onSubmit }) => {
  return (
    <styles.Page>
      <styles.HeaderArea>
        <styles.PageBranding>
          <styles.SparkleIcon><AutoAwesome size={32} /></styles.SparkleIcon>
          <styles.BrandingTitle>Willow Create</styles.BrandingTitle>
        </styles.PageBranding>
        <styles.Subtitle mb={24}>
          Enter your company website URL to generate high-quality social posts.
        </styles.Subtitle>
      </styles.HeaderArea>

      <styles.CenterArea>
        <BatchUrlForm size="large" onSubmit={onSubmit} buttonText="Generate Posts" />
      </styles.CenterArea>

      <styles.SpacerArea />
    </styles.Page>
  );
};

export default SearchPage;
